import React from "react"
import { Box, Container, useTheme, useMediaQuery } from "@mui/material"
import { deepmerge } from "@mui/utils"
import clsx from "clsx"

import { AppNavigation as DefaultAppNavigation } from "containers/AppNavigation"
import { AppDesktopNavigation as DesktopNavigation } from "containers/DesktopNavigation"
import { IPageLayoutProps } from "./interface"
import { LegacyHeader } from "components/Header/LegacyHeader"
import { useLocation } from "react-router-dom"

const SPECIAL_TITLE = ["navigate", "dir", "place"]

export const PageLayout: React.FC<IPageLayoutProps> = ({
  children,
  header = null,
  footer = null,
  AppNavigation,
  sx = {},
  ...props
}) => {
  const theme = useTheme()
  const matchDownMd = useMediaQuery(theme.breakpoints.down("md"))
  const styleOverrides = theme.components[`AppPageLayout`]?.styleOverrides || {}
  const { root, container, navigationContainer, headerContainer } =
    styleOverrides

  AppNavigation =
    AppNavigation ?? (matchDownMd ? DefaultAppNavigation : DesktopNavigation)
  const location = useLocation()
  const pathName = location.pathname.split("/")
  const defaultTitle = pathName[1]?.split("-").join(" ")
  const specialTitle = SPECIAL_TITLE.find((title) => pathName.includes(title))
  const pageTitle = specialTitle ? specialTitle : defaultTitle

  return (
    <Box sx={deepmerge(root, sx)} {...props} data-name="PageLayout">
      <Box className={clsx("Header-Container", pageTitle)} sx={headerContainer}>
        {header || <LegacyHeader />}
      </Box>

      <Container
        maxWidth="md"
        sx={container}
        className="AppPageLayout-Container"
      >
        {children}
      </Container>

      <Box
        className="AppPageLayout-NavigationContainer"
        sx={navigationContainer}
      >
        <AppNavigation />
      </Box>
    </Box>
  )
}
